
<p-progressBar
	[mode]="mode"
	[style]="{'height': '6px', 'border-radius': 0, 'position': 'fixed', 'width': '100%'}"
	[hidden]="!loading"></p-progressBar>